export const initJsonSchema = () => {
  const keyEls = document.querySelectorAll('.schema-item .schema-key');

  keyEls.forEach((keyEl) => {
    keyEl.addEventListener('click', (e) => {
      e.stopPropagation();
      keyEl.parentElement?.classList.toggle('collapsed');
    });
  });
};
